import { render, staticRenderFns } from "./homeTrain.vue?vue&type=template&id=a9aa33de&scoped=true&"
import script from "./homeTrain.vue?vue&type=script&lang=js&"
export * from "./homeTrain.vue?vue&type=script&lang=js&"
import style0 from "./homeTrain.vue?vue&type=style&index=0&id=a9aa33de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aa33de",
  null
  
)

component.options.__file = "homeTrain.vue"
export default component.exports